import styled from 'styled-components';

import { Button, Card, Grid2 as Grid } from '@mui/material';

export const ContentContainer = styled(Card)`
  box-shadow: none;
`;
export const ClearFilterButton = styled(Button)`
  margin-left: 1rem;
  text-transform: none;
  text-decoration: underline;
  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
    text-decoration: underline;
  }
`;

export const ButtonFilterContainer = styled(Grid)`
  max-height: 40px;
`;

export const WrapperContainerBlur = styled.div`
  filter: blur(5px);
  pointer-events: none;
`;
